<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center gap-8">
      <div class="box-logo">
        <i class="icon-COIN text-red font-24"></i>
      </div>
      <span class="font-16 font-w-500">มียอดซื้อใน 1 เดือน :</span>
    </v-col>
    <v-col cols="12" class="pt-0">
      <div class="d-flex flex-wrap">
        <section
          v-for="(item, index) in bpDetail.product_group"
          :key="index"
          :class="item.coverage ? 'box-group--blue' : 'box-group--grey'"
        >
          <span>{{ item.product_group }}</span>
        </section>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.box-logo {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #faf3f4;
}

.box-group {
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  padding: 8px;
  margin: 4px;
  border-radius: 8px;

  &--blue {
    @extend .box-group;
    background: #4a90e2;
  }
  &--grey {
    @extend .box-group;
    background: #c4c4c4;
  }
}
</style>
